import { useMutation } from '@tanstack/react-query';
import { useTableEditingContext } from 'components/atoms/EditableDataGrid/TableEditingContext';
import { Procedure } from 'interfaces/procedure';
import { ProceduresFieldsContext } from 'interfaces/procedure/fields/helpers';
import { useSnackbar } from 'notistack';
import { downloadBlob } from 'utils/exports';
import { createManifestTemplateWorkbook } from './manifestWorkbook';

export const useManifestTemplateDownload = () => {
  const { fieldsContext } = useTableEditingContext<Procedure, ProceduresFieldsContext>();
  const { enqueueSnackbar } = useSnackbar();
  const mutation = useMutation({
    mutationFn: async () => {
      const blob = await createManifestTemplateWorkbook(fieldsContext);
      downloadBlob(blob, 'case_manifest_template.xlsx');
    },
    onError: (error) => {
      console.error(error);
      enqueueSnackbar('Could not download the manifest template. Try again.', { variant: 'error' });
    },
  });
  return {
    ...mutation,
    isLoading: mutation.isLoading || fieldsContext.allCancerTypesLoading || fieldsContext.uiSettingsLoading,
  };
};
